import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import Home from "./pages/Home";
import Trading from "./pages/Trading";
import Sponsorship from "./pages/Sponsorship";
import AccountSpecification from "./pages/AccountSpecification";
import Partner from "./pages/Partner";
import About from "./pages/About";

// Мягкая анимация появления/исчезновения
const pageVariants = {
  initial: { opacity: 0, y: 20 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: { duration: 0.4, ease: "easeIn" },
  },
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        style={{
          width: "100%",
          minHeight: "100vh",
          backgroundColor: "#ffffff", // ← белый фон
          transition: "background-color 0.8s ease", // плавная смена фона
        }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/trading" element={<Trading />} />
          <Route path="/sponsor" element={<Sponsorship />} />
          <Route path="/account" element={<AccountSpecification />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/aboutus" element={<About />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
